<template>
  <div
    v-if="isHeaderSticky"
    class="tw:fixed! tw:top-0 tw:left-1/2 tw:-translate-x-1/2 tw:z-[100] tw:flex tw:h-14 tw:w-full tw:max-w-[500px] tw:items-end tw:gap-1 tw:bg-white tw:px-4"
  >
    <nuxt-img
      src="/img/main/usimsa-logo-v2.svg"
      alt="usimsa"
      height="24"
    />
    <span class="tw:typo-title-s tw:font-bold tw:leading-none tw:text-usdg-color-brand-800">혜택</span>
  </div>
  <div class="tw:relative">
    <div
      class="tw:pointer-events-none tw:absolute! tw:inset-x-0 tw:top-0 tw:h-[216px] tw:bg-gradient-to-b tw:from-[#c8e1ff] tw:to-[rgba(235,245,255,0)]"
    />
    <div class="tw:relative tw:px-4 tw:pt-4 tw:pb-5">
      <div class="tw:flex tw:items-center tw:justify-between tw:pt-2">
        <div class="tw:flex tw:flex-col tw:gap-[9px]">
          <div class="tw:flex tw:items-end tw:gap-1">
            <nuxt-img
              src="/img/main/usimsa-logo-v2.svg"
              alt="usimsa"
              height="24"
            />
            <span class="tw:typo-title-s tw:font-bold tw:leading-none tw:text-usdg-color-brand-800">혜택</span>
          </div>
          <p class="tw:typo-title-xs tw:font-semibold tw:text-usdg-color-text-title">
            {{ greetingName }}님을 위해 준비했어요
          </p>
        </div>
        <nuxt-img
          src="/img/benefit/gift.webp"
          alt="gift"
          class="tw:size-14"
        />
      </div>

      <div class="tw:flex tw:gap-2.5 tw:mt-4 tw:py-4">
        <nuxt-link
          id="gtm_benefit_main_point_btn"
          to="/user/point"
          class="tw:flex tw:flex-1 tw:flex-col tw:gap-4 tw:rounded-xl tw:border tw:border-usdg-color-border-medium tw:bg-white tw:py-3.5 tw:pl-3.5 tw:pr-2.5 tw:min-w-0"
        >
          <span class="tw:typo-text-l tw:font-bold tw:text-usdg-color-text-title tw:break-keep"
            >적립금</span
          >
          <div class="tw:flex tw:items-center tw:justify-end tw:gap-0.5">
            <span class="tw:typo-title-xs tw:font-bold tw:text-usdg-color-brand-500 tw:break-keep"
              >{{ comma(userData?.point || 0) }}원</span
            >
            <IUsdgNormalChevronRightSmallIcon class="tw:size-4! tw:mb-0! tw:shrink-0 tw:text-usdg-color-gray-600" />
          </div>
        </nuxt-link>
        <nuxt-link
          id="gtm_benefit_main_coupons_btn"
          to="/user/coupons"
          class="tw:flex tw:flex-1 tw:flex-col tw:gap-4 tw:rounded-xl tw:border tw:border-usdg-color-border-medium tw:bg-white tw:py-3.5 tw:pl-4 tw:pr-2.5 tw:min-w-0"
        >
          <span class="tw:typo-text-l tw:font-bold tw:text-usdg-color-text-title tw:break-keep"
            >쿠폰</span
          >
          <div class="tw:flex tw:items-center tw:justify-end tw:gap-0.5">
            <span class="tw:typo-title-xs tw:font-bold tw:text-usdg-color-brand-500 tw:break-keep"
              >{{ userData?.userCoupons?.length || 0 }}장</span
            >
            <IUsdgNormalChevronRightSmallIcon class="tw:size-4! tw:mb-0! tw:shrink-0 tw:text-usdg-color-gray-600" />
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { comma } = useUi()
const { userData } = storeToRefs(useUserData())
const { isLoginStatus } = storeToRefs(useAuthStore())

const { y } = useScroll(window)
const isHeaderSticky = computed(() => y.value > 10)

const greetingName = computed(() =>
  isLoginStatus.value ? userData.value?.userName : '유심사 회원'
)
</script>
